export default __webpack_public_path__ + "static/media/support-allied-victor-valle.3d313bb6.png";